"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COLORS = exports.MAX_SLIDER_ROUND_VALUE = void 0;
exports.MAX_SLIDER_ROUND_VALUE = 1000;
var DEFAULT_COLORS;
(function (DEFAULT_COLORS) {
    DEFAULT_COLORS["BLUE_LIGHT"] = "#6CCCDD";
    DEFAULT_COLORS["BLUE_DARK"] = "#153063";
    DEFAULT_COLORS["RED"] = "#C70000";
    DEFAULT_COLORS["GREEN_LIGHT"] = "#65CE24";
    DEFAULT_COLORS["ORANGE_LIGHT"] = "#F6B552";
    DEFAULT_COLORS["YELLOW_LIGHT"] = "#FCE516";
    DEFAULT_COLORS["WHITE"] = "#FFFFFF";
})(DEFAULT_COLORS || (exports.DEFAULT_COLORS = DEFAULT_COLORS = {}));
